/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { OAuthStartInProvider } from './oAuthStartInProvider';

export interface OAuthStartIn {
  provider: OAuthStartInProvider;
  login_hint?: string | null;
}
